// Imports
import { Props } from '.';
import CardContainer from './container';


// Define the accepted props
interface CompleteProps extends Props {
	uniqueID: React.MutableRefObject<string>;
}


// Function component
const SuspenseFallback: React.FC<CompleteProps> = ({ bindGetter, ...props }) => <CardContainer {...props} isLoading />;

export default SuspenseFallback;
